import { render, staticRenderFns } from "./ProtonsIndex.vue?vue&type=template&id=7fdb516d&"
import script from "./ProtonsIndex.vue?vue&type=script&lang=js&"
export * from "./ProtonsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports